import Orders from 'components/orders';

const OrderPage = () => {
  return <Orders />;
};

export default OrderPage;
